module.exports = __webpack_public_path__ + "img/SS.a47cdbb2.png";